import { debounce as _debounce, curry } from 'lodash/fp';

const debounceNotFixed = _debounce.convert({ fixed: false });

export const debounce = curry((options, wait, fn) => debounceNotFixed(wait)(fn, options));
